import { Component, OnInit, OnChanges, Input, Output, EventEmitter, ChangeDetectorRef } from '@angular/core';
import { IMyOptions, IMyDateModel, IMyDate } from 'mydatepicker';
import { log } from 'util';

@Component({
  selector: 'datepicker',
  templateUrl: './datepicker.component.html',
  styleUrls: ['./datepicker.component.css']
})
export class DatepickerComponent implements OnInit, OnChanges {
    @Input() datum: Date;
    @Input() disabled: boolean;
    @Output() datepickerOnDateChanged: EventEmitter<Date> = new EventEmitter<Date>();
    @Input() disableUntil: IMyDate = { year: 1752, month: 12, day: 12 };
    public model: Object;
    myDatePickerOptions: IMyOptions = {
        disableUntil: { year: 1752, month: 12, day: 31 },
        todayBtnTxt: "Danas",
        dateFormat: 'dd.mm.yyyy.',
        firstDayOfWeek: 'mo',
        sunHighlight: true,
        height: '31px',
        width: '100%',
        inline: false,
        selectionTxtFontSize: '13px',
        dayLabels: {
            su: "Ned",
            mo: "Pon",
            tu: "Uto",
            we: "Sri",
            th: "Čet",
            fr: "Pet",
            sa: "Sub",
        },
        monthLabels: {
            1: "Januar",
            2: "Februar",
            3: "Mart",
            4: "April",
            5: "Maj",
            6: "Jun",
            7: "Jul",
            8: "Avgust",
            9: "Septembar",
            10: "Oktobar",
            11: "Novembar",
            12: "Decembar",
        }
    };

  constructor() { }

    ngOnInit() {
        this.myDatePickerOptions.disableUntil = this.disableUntil
        if (this.datum != undefined && this.datum != null) {
            this.model = {
                date: {
                    year: new Date(this.datum).getFullYear(),
                    month: new Date(this.datum).getMonth() + 1,
                    day: new Date(this.datum).getDate()
                }
            };

            if (new Date(this.datum).getFullYear() < 1900)
                this.model = null;
        }
    }

    ngOnChanges() {
        if (this.datum != undefined && this.datum != null) {
            this.model = {
                date: {
                    year: new Date(this.datum).getFullYear(),
                    month: new Date(this.datum).getMonth() + 1,
                    day: new Date(this.datum).getDate()
                }
            };

            if (new Date(this.datum).getFullYear() < 1900)
                this.model = null;
        }
        else {
            this.model = null;
        }

    }

    datePickerChanged(event: IMyDateModel) {
        if (event.date != null &&
            event.date.year != null && event.date.month != null && event.date.day != null &&
            event.date.year > 1752 && event.date.month > 0 && event.date.day > 0) {
            let retVal = new Date(event.date.year, event.date.month - 1, event.date.day);
            var userTimezoneOffset = retVal.getTimezoneOffset() * 60000;
            this.datepickerOnDateChanged.emit(new Date(retVal.getTime() - userTimezoneOffset));
        }
        else
            this.datepickerOnDateChanged.emit(null);
    }
}
